<template>
  <bj-modal
    v-model="takeOverAssign.visible"
    size="auto"
    title="Take-over assign"
  >
    <div slot="content">
      <div class="row gutter-sm">
        <q-field class="col-auto">
          <q-select
            v-model="takeOverAssignData.newAsignee"
            float-label="Choose a business member"
            :options="takeOverAssignData.selectOptions"
          />
          <span v-if="takeOverAssignData.currentAgent && takeOverAssignData.newAsignee">
            Current agent {{ takeOverAssignData.currentAgent }} will receive a system cancellation message
          </span>
        </q-field>
        <div class="col-auto">
          <q-btn
            :disabled="!takeOverAssignData.newAsignee"
            outline
            label="Take-over Assign"
            @click="submitTakeOverAssign"
          />
        </div>
      </div>
    </div>
  </bj-modal>
</template>

<script>
import get from 'lodash.get';

export default {
  name: 'BjTakeOverAssignModal',
  components: {},
  props: {
    takeOverAssign: {
      type: Object,
      required: true,
    },
  },
  data() {
    const takeOverAssignData = {
      selectOptions: [],
      currentAgent: null,
      newAsignee: null,
    };
    return { takeOverAssignData };
  },
  async mounted() {
    this.takeOverAssignData.currentAgent = get(this.takeOverAssign.payload.inquiry, 'tour.user.full_name');
    await this.fetchBusiness();
  },
  methods: {
    async fetchBusiness() {
      this.business = await this.api().request('GET', `businesses/${this.takeOverAssign.payload.inquiry.property.business_id}`);
      this.takeOverAssignData.selectOptions = [];
      this.users = this.business.users.filter((user) => user.verified).reduce((accumulator, user) => {
        accumulator[user.id] = {
          name: user.full_name,
          id: user.id,
        };
        this.takeOverAssignData.selectOptions.push({
          label: user.full_name,
          value: user.id,
        });
        return accumulator;
      }, {});
    },
    submitTakeOverAssign() {
      if (this.takeOverAssignData.newAsignee) {
        const selectedUser = this.users[this.takeOverAssignData.newAsignee];

        this.uiConfirm(`Are you sure you want to assign this tour to ${selectedUser.name}?`).then(() => {
          this.takeOverAssign.loading = true;
          this.api().request('POST', `admin/schedules/${this.takeOverAssign.payload.inquiry.schedule_inquiry.schedule_id}/takeovers`, {
            assignee_id: selectedUser.id,
            take_over_assign: true,
          }).then((response) => {
            this.takeOverAssign.loading = false;
            this.uiNotify(`Tour assigned to ${selectedUser.name} successfully`);
            this.$root.$emit('take-over-assigned', response);
          }).catch((error) => {
            this.takeOverAssign.loading = false;
            this.uiNotify(this.getFirstError(error) || error.message || 'Error occurred', 'negative');
          });
        });
      }
    },
  },
};
</script>
